import { createAsyncThunk } from '@reduxjs/toolkit';
import {
	convertBase64ImageToFile,
	createNewCharacterService,
	uploadCharacterImageAssetService,
} from 'api/services/CharacterService';
import { getImageDimensionsFromFileAsync } from 'core/utils/utils';

export const uploadCharacterImageAsync = createAsyncThunk(
	'characterStudio/uploadCharacterImage',
	async ({ characterImage, isSampleAssets, characterAssetId }) => {
		if (isSampleAssets) {
			return characterAssetId;
		}
		return getImageDimensionsFromFileAsync(characterImage)
			.then((imageDimensions) =>
				convertBase64ImageToFile(characterImage).then((file) => ({ imageDimensions, file })),
			)
			.then((data) => {
				const { imageDimensions, file } = data;
				const [width, height] = imageDimensions;
				return uploadCharacterImageAssetService(file, {
					width,
					height,
					type: file.type,
				})
					.then(({ asset, image }) => {
						return { id: asset?.id, url: image };
					})
					.catch((error) => {
						throw new Error(error?.message);
					});
			});
	},
);

export const createNewCharacterAsync = createAsyncThunk(
	'characterStudio/createNewCharacterAsync',
	async ({ characterData, characterImage, isSampleAssets }, { dispatch }) => {
		if (isSampleAssets) {
			return createNewCharacterService({ ...characterData, image: characterImage }, { dispatch });
		}
		return getImageDimensionsFromFileAsync(characterImage)
			.then((imageDimensions) =>
				convertBase64ImageToFile(characterImage).then((file) => ({ imageDimensions, file })),
			)
			.then((data) => {
				const { imageDimensions, file } = data;
				const [width, height] = imageDimensions;
				return uploadCharacterImageAssetService(file, {
					width,
					height,
					type: file.type,
				})
					.then(({ image }) => ({ ...characterData, image }))
					.catch((error) => {
						throw new Error(error?.message);
					});
			})
			.then((character) => createNewCharacterService(character, { dispatch }));
	},
);
